// GENERATED FILE - DO NOT MODIFY
export enum TimeKeepingStatus {
    In = "I",
    Out = "O",
    DidNotWork = "Z",
}

export let nameof = "TimeKeepingStatus";
